import Vue from 'vue';
import App from './App.vue';
import vuetify from './plugins/vuetify'
import router from './router';
import apiConfig from './api/config';
import "./plugins/jquery";
import "./plugins/snotify";
import "./components";
import { store } from './store/index'

//Report Viewer source
import '@boldreports/javascript-reporting-controls/Scripts/bold.report-viewer.min';
import '@boldreports/javascript-reporting-controls/Scripts/bold.report-designer.min';

//Data-Visualization
import '@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.bulletgraph.min';
import '@boldreports/javascript-reporting-controls/Scripts/data-visualization/ej.chart.min';

Vue.config.productionTip = true;
apiConfig.setup();

new Vue({
    store,
    vuetify,
    router,
    mounted() {
        Vue.$snotify = this.$snotify;
    },
    render: h => h(App),
}).$mount('#app');
